<template>
  <div id="indexId">
    <el-row>
      <el-col :xs="24" :md="12">
        <el-card :header="$t('Labour-hour Calendar')" style="height: 640px;">
          <el-row>
            <el-col :xs="24" >
              <div class="buttonDiv">
                <el-button type="primary" size="mini" @click="labourHour">{{$t('Labour Hour Logging（Free-format）')}}</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" >
                <el-calendar v-model="value">
                  <template slot="dateCell" slot-scope="{date, data}">
                    <div @click="myLabourHour(data)" style="width: 100%;height: 100%;">
                      <div style="float: left;">{{data.day.split('-').slice(2).join()}}</div>
                      <div v-for="item in holidays" :key="item.holidayDate">
                        <div v-if="data.day == item.holidayDate" style="margin-top: 20px;float: right;">
                          <div v-if="item.isHoliday == 'Yes'" >
                            <p style="color: #6ed60f;" >{{item.workHours>0?item.workHours:''}}</p>
                          </div>
                          <div v-if="item.isHoliday == 'No'" >
                            <p v-if="item.workHours >= 8" style="color: #6ed60f;" >{{item.workHours==0?0:item.workHours}}</p>
                            <p v-if="item.workHours < 8" style="color: tomato;" >{{item.workHours==0?0:item.workHours}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-if="data.day.split('-').slice(1)[0] == month" style="margin-top: 10px;">
                      <p style="color: tomato;" v-if="handleSelected(data.day) == 0">{{0}}</p>
                      <p style="color: tomato;" v-if="handleSelected(data.day) != 0">{{handleSelected(data.day)}}</p>
                    </div> -->
                  </template>
                </el-calendar>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :xs="24" :md="12">
        <el-card :header="$t('To-do E-Process')" style="height: 640px;">

        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :md="12">
        <el-card :header="$t('Dashboard')" style="height: 150px;">

        </el-card>
      </el-col>
      <el-col :xs="24" :md="12">
        <el-card :header="$t('Announcement& System document')" style="height: 150px;">

        </el-card>
      </el-col>
    </el-row>
    
  </div>
</template>
<script>
    export default {
        name: 'indexw',
        created () {
           this.getUserHolidayAndHour();
        },
        data () {
            return {
              value: new Date(),
              month: null,
              labours: [],
              holidays: [],
            }
        },
        methods: {
          getUserHolidayAndHour(){
            let url =`${this.$store.state.islhurl}holiday/getUserHolidayAndHour`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(pm);
            this._post(url,pm).then(
              res => {   
                this.holidays = res.holidays;
              }
            )
          },
          getUserHour(){
            let url =`${this.$store.state.islhurl}labourHour/getHour`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.labours = res.labours;
                let currDate = new Date();
                this.month = currDate.getMonth()+1;
              }
            )
          },
          handleSelected(day) {
            let labourInfo = this.labours.find(item => {
              return item.workDate === day;
            })
            let hour = 0;
            if(labourInfo != null){
              hour = labourInfo.workHours;
            }
            return hour;
          },
          labourHour(){
            this.$router.push({path:'/labourEnter'});
            this.$store.commit('tagChange', 'labourEnter');
          },
          myLabourHour(data){
            let homeDate = [data.day,data.day];
            let pm = {
              homeDate: homeDate,
              indexTolEngineer: 'N',
            }
            this.$router.push({name:'labourEngineer',params:pm})
            this.$store.commit('tagChange', 'labourEngineer');
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/login/index.vue